import { FC } from "react";
import ModalHeading from "../ModalHeading";
import { greenLoadingSVG } from "../../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";

interface SubmittedDetailsProps {}

const SubmittedDetails: FC<SubmittedDetailsProps> = ({}) => {
  const intl = useIntl();
  return (
    <div className="space-y-6  p-8">
      <ModalHeading
        title={intl.formatMessage({ id: "thank_you" })}
        description={intl.formatMessage({
          id: "we_are_currently_checking_your_information",
        })}
      />

      <div className="flex justify-center items-center">{greenLoadingSVG}</div>
    </div>
  );
};

export default SubmittedDetails;
